import { useState } from "react";
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from "@mui/material";
import { addUser } from "../../services/authService";


interface EditViewModalProps {
  open: boolean;
  onClose: () => void;
  user: User | null;
}

const EditViewModal: React.FC<EditViewModalProps> = ({ open, onClose, user }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");


  const handleSave = async () => {
    await addUser(username, password);
    setUsername("");
    setPassword("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{user ? "Editar Usuario" : "Agregar Usuario"}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Nombre de Usuario"
          margin="dense"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <TextField
          fullWidth
          label="Clave"
          margin="dense"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>

        <Button onClick={handleSave} color="primary">
          {user ? "Actualizar" : "Agregar"}
        </Button>

      </DialogActions>
    </Dialog>
  );
};

export default EditViewModal;